import { Spin } from "antd";
import "./spin.scss";
export default Spin;
